<template>
  <div>
    <h1>Usunąć promocję {{ promotionType }}{{ promotionName }}?</h1>
    <button @click="deletePromotion" class="btn btn-red">Usuń</button>
  </div>
</template>

<script>
export default {
  name: "DeletePromotionModal",
  computed: {
    promotionId() {
      return this.$store.getters.promotionToRemove.id;
    },
    promotionName() {
      return this.$store.getters.promotionToRemove.name;
    },
    promotionType() {
      const { type } = this.$store.getters.promotionToRemove;
      if (type === 0) {
        return "#";
      }

      if (type === 1) {
        return "@";
      }

      return "";
    }
  },
  methods: {
    deletePromotion() {
      this.$store.dispatch('deletePromotion', this.promotionId);
    }
  }
};
</script>
